import {
  DictionaryAutocomplete,
  useListSource,
  useAutocompleteSource,
  Params,
  ResultDto,
  useFetch,
  ListSource,
} from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

import { OvzFacility, MinimalDistances } from '../../models';
import { useState, useEffect, useMemo } from 'react';

export function useMinimalDistancesCategoryAutocomplete(params?: Params) {
  return useAutocompleteSource<DictionaryAutocomplete>({
    url: `${EvidenceAPI.MINIMAL_DISTANCES_CATEGORY}/autocomplete`,
    params,
  });
}

export function useMinimalDistancesCategory() {
  return useListSource<DictionaryAutocomplete>({
    url: `${EvidenceAPI.MINIMAL_DISTANCES_CATEGORY}/list`,
    method: 'POST',
  });
}

export function useMinimalDistancesDeterminationMethodAutocomplete(
  params?: Params
) {
  return useAutocompleteSource<DictionaryAutocomplete>({
    url: `${EvidenceAPI.MINIMAL_DISTANCES_DETERMINATION_METHOD}/autocomplete`,
    params,
  });
}

export function useMinimalDistances(params?: Params) {
  return useFetch<ResultDto<MinimalDistances>>(
    `${EvidenceAPI.MINIMAL_DISTANCES}/list`,
    {
      method: 'POST',
      body: JSON.stringify(params),
      headers: { 'Content-Type': 'application/json' },
    }
  );
}

export function useOVZFacilityDetail(id?: string) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<OvzFacility>();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      console.log('fetching OVZ, id = ', id);
      try {
        const response = await fetch(`${EvidenceAPI.OVZ_FACILITIES}/${id}`);
        if (response.ok) {
          const json = await response.json();
          setResult(json);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    };
    if (id) {
      load();
    }
  }, [id]);

  return { loading, result };
}

export function useMinimalDistancesCategorySource() {
  const [result, loading, reset] = useFetch<ResultDto<DictionaryAutocomplete>>(
    EvidenceAPI.MINIMAL_DISTANCES_CATEGORY + '/autocomplete',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sort: [
          {
            field: 'code',
            order: 'ASC',
            type: 'FIELD',
          },
        ],
        size: -1,
      }),
    }
  );

  const source: ListSource<DictionaryAutocomplete> = useMemo(
    () => ({
      items: result?.items ?? [],
      loading,
      reset,
      loadDetail: async (item) => item,
    }),
    [loading, reset, result]
  );

  return source;
}

export function useMinimalDistancesDeterminationMethodSource() {
  const [result, loading, reset] = useFetch<ResultDto<DictionaryAutocomplete>>(
    EvidenceAPI.MINIMAL_DISTANCES_DETERMINATION_METHOD + '/autocomplete',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sort: [
          {
            field: 'code',
            order: 'ASC',
            type: 'FIELD',
          },
        ],
        size: -1,
      }),
    }
  );

  const source: ListSource<DictionaryAutocomplete> = useMemo(
    () => ({
      items: result?.items ?? [],
      loading,
      reset,
      loadDetail: async (item) => item,
    }),
    [loading, reset, result]
  );

  return source;
}
